import React from 'react';
import './title.component.scss';
import { Input } from 'antd';

function Title({ isEditing, content, setContent }) {
  return (
    <div>
      {isEditing ? (
        <Input
          value={content}
          maxLength={100}
          onChange={(e) => setContent(e.target.value)}
        />
      ) : (
        <span style={{ wordBreak: 'break-word' }}>{content}</span>
      )}
    </div>
  );
}

export default Title;
